import React from 'react';
import { Route } from 'react-router-dom';
import DarAnalysis from '../../Daranalysis/Darfiles/QuestionUplode.js';
import DarAnswer from '../../Daranalysis/Darfiles/EnterDarAnswer.js';
import DarQuestions from '../../Daranalysis/Darfiles/ViewQuestions.js';
import Distributor from '../../Daranalysis/Darfiles/Distributorpage.js';
import DarAnswerData from '../../Daranalysis/Darfiles/Potentialdata.js';
import DarAnswerDristributor from '../../Daranalysis/Darfiles/DarAnswerWeightage.js';
import DarFullAnswer from '../../Daranalysis/Darfiles/DarFullAnswer.js';
import Carddar from '../../Daranalysis/CardsGrid.js';

export const darRoutes = [
  <Route key="dar-list" path="/dar-List" element={<Carddar />} />,
  <Route key="dar-distributor" path="/DarDistributor" element={<Distributor />} />,
  <Route key="dar-question-upload" path="/DarQuestion-uplode" element={<DarAnalysis />} />,
  <Route key="dar-questions" path="/Update-DarQuestions" element={<DarQuestions />} />,
  <Route key="dar-answer" path="/Take-DarAnalysis" element={<DarAnswer />} />,
  <Route key="dar-potential" path="/Dar-Potentiallevel" element={<DarAnswerData />} />,
  <Route key="dar-answer-value" path="/DarAnswer-value" element={<DarAnswerDristributor />} />,
  <Route key="dar-full-answer" path="/DarFullAnswer" element={<DarFullAnswer />} />,
];
